import React, { Component } from 'react'
import Select from 'react-select';
import { getUser } from '../../../actions/session';
import axios from 'axios';
import { BALANCE_ADD } from '../../../config/rest_endpoints';
import { Notifications } from '../../common/notification';


 class Debit_Credit extends Component {
     constructor(props) {
         super(props)
         this.state = {
             User:getUser(),
            amount:'',
             accountType: { value: '1', label: 'Credit' },
            optionsAccountType: [
                { value: '1', label: 'Credit' },
                { value: '2', label: 'Debit' }
            ],
            userId:this.props.userId,
             isLoad: false
         }
         this.onHandleChange = this.onHandleChange.bind(this)
         this.onSubmitBalance = this.onSubmitBalance.bind(this)
         this.handleSelectAccount = this.handleSelectAccount.bind(this)
     }
    
    onHandleChange(e) {
        this.setState({[e.target.name]:e.target.value})
    }
    
    handleSelectAccount(accountType) {
        this.setState({ accountType });
        console.log(`Option selectedCharges:`, accountType);
    };

    clearForm() {
        this.setState({
            amount:'',
            accountType:null,
        })
    }

    onSubmitBalance() {
        const {User,amount,accountType,userId} = this.state
        const addBalance = {
            amount:parseFloat(amount),
            type:parseInt(accountType.value),
        }
       console.log('addBalance :', addBalance);
        this.setState({ isLoad: true })
        var headers= {'Authorization': "Bearer " + User.token}
        axios.post(`${BALANCE_ADD}/${userId}/payment`,addBalance,{headers}).then(res=>{
            if(res) {
                this.setState({
                    msg:res.data.message,
                    isLoad: false
                })
                Notifications.notify(this.state.msg, "Created", "success")
            }
            else {
                Notifications.notify("Add failed", "error", "errors");
            }
            this.clearForm()
        }).catch(err=>{
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({ isLoginURL: true })
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isLoad: false
            })
        })
    }
    render() {
        const {amount,accountType,optionsAccountType} = this.state
        return (
            <div>
                <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body">
                    {/* <div className="card-body"> */}
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <div className="mb-2">
                                    <label style={{fontWeight:'400',fontSize:'16px'}}>Amount</label>
                                    <input type="number" className="form-control" name="amount" value={amount} onChange={this.onHandleChange} placeholder="Enter amount" />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="">
                                <label style={{fontWeight:'400',fontSize:'16px'}}>Type</label>
                                <Select
                                    value={accountType}
                                    onChange={this.handleSelectAccount}
                                    options={optionsAccountType}
                                />
                                </div>
                            </div>
                        </div>
                        {/* row */}
                        <div className=" ml-auto">
                            <button type="submit" className="main-button btn btn-success btn-sm" onClick={this.onSubmitBalance} >Add Balance<i class={this.state.isLoad ? "icon-spinner4 spinner ml-1 " : 'icon-coin-dollar ml-1 '}></i></button>
                        </div>
                    {/* </div> */}
                </div>
            </div>
        )
    }
}
export default Debit_Credit